import { BottomNavigation, BottomNavigationProps } from '@mui/material'
import React from 'react'

const BottomNavigationWrapper = React.forwardRef<HTMLDivElement, BottomNavigationProps>((props, ref) => (
  <BottomNavigation {...props} ref={ref} />
))

export default BottomNavigationWrapper
